import React from 'react';

const Navbar = () => {
  return (
    <nav className="fixed w-full bg-white/90 backdrop-blur-md z-50 border-b border-slate-100">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <div className="flex-shrink-0 flex items-center">
          <img 
            src="https://media-manager-c.questera.ai/greta-media/2fbbf08e099a9ef9870e1c5f3effee5d6d36993ea30e1b10ed25bd1173bb5e1eabb168f88e9bc68e478ef3a4b0682ce3/images/aW1hZ2UvcG5n/061b124a453d246acf528d3d89a4cc45.png" 
            alt="GeoSpaceWeb Logo" 
            className="h-10 w-auto object-contain" 
          />
        </div>
        <div>
          <a style={{
      color: 'rgb(255, 255, 255)'
    }} 
            href="https://meetings-na2.hubspot.com/geospaceweb/call"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-brand-600 hover:bg-brand-700 text-white px-4 py-2 rounded-full font-medium text-sm transition-colors shadow-sm"
          >Choose a Time</a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;